import { render } from "./ModalJitsiMeet.vue?vue&type=template&id=34686bca"
import script from "./ModalJitsiMeet.vue?vue&type=script&lang=js"
export * from "./ModalJitsiMeet.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__